/** Pure MIME to file-extension mapping, chiefly so Safari MP4 and M4A recordings are not saved as `.webm`. */

/** Prefix-matched table where the first match wins, so specific prefixes must precede broader ones. */
export const MIME_TO_EXTENSION: ReadonlyArray<readonly [string, string]> = [
  ["video/mp4", "mp4"],
  ["video/webm", "webm"],
  ["video/ogg", "ogv"],
  ["video/x-matroska", "mkv"],
  ["audio/mp4", "m4a"],
  ["audio/aac", "aac"],
  ["audio/mpeg", "mp3"],
  ["audio/mp3", "mp3"],
  ["audio/ogg", "ogg"],
  ["audio/wav", "wav"],
  ["audio/webm", "webm"],
];

/** Fallback extension for null/unknown/empty MIME types. */
const DEFAULT_EXTENSION = "webm";

/** Derive an extension from a MIME string, falling back to `webm`. */
export function extensionForMime(mimeType: string | null | undefined): string {
  if (!mimeType) return DEFAULT_EXTENSION;
  const normalized = mimeType.toLowerCase();
  for (const [prefix, extension] of MIME_TO_EXTENSION) {
    if (normalized.startsWith(prefix)) return extension;
  }
  return DEFAULT_EXTENSION;
}

/** Derive an extension from a blob's MIME type, falling back to `webm`. */
export function extensionForBlob(blob: Blob | null): string {
  return extensionForMime(blob?.type);
}
